<style>
  :host {
    width: 100%;
  }
</style>

@let isInsideSummary = $isInsideSummary();

@if (
  (permissionService.canLogistAddDevices$ | async) &&
  !$request().isCompleted &&
  doesCurrentRequestHasDevicesInProducts()
) {
  @if (!$isAddNewDeviceFormShown()) {
    @if (!isInsideSummary) {
      <div class="text-center">
        <button
          tuiButton
          type="button"
          size="m"
          (click)="showDeviceAddingForm()"
          class="min-w-[150px]"
        >
          <tui-icon
            [style.border-width.rem]="0.25"
            icon="@tui.plus"
            class="mr-2"
          ></tui-icon>
          {{ 'request_form.devices.add_device.add_button' | translate }}
        </button>
      </div>
    }
  } @else {
    <div class="flex justify-center" #addDeviceForm>
      <div
        class="x-card x-card_size_m x-white w-full md:w-2/3 lg:w-1/2 2xl:w-1/3"
      >
        <div [formGroup]="formGroup">
          <div class="x-input-label">
            {{ 'request_form.devices.add_device.sim_1' | translate }}
          </div>
          <tui-textfield
            iconStart="@tui.plus"
            class="x-textfield-icon-s"
            [tuiTextfieldCleaner]="true"
          >
            <input
              [formControlName]="FormFields.Sim1"
              [maskito]="simMask"
              [tuiUnmaskHandler]="unmaskSim"
              tuiInput
              class="font-extrabold!"
              inputmode="numeric"
            />
          </tui-textfield>
          <tui-error [formControlName]="FormFields.Sim1"></tui-error>
          <div class="x-input-label">
            {{ 'request_form.devices.add_device.sim_2' | translate }}
          </div>
          <div class="flex flex-col">
            <tui-textfield
              iconStart="@tui.plus"
              class="x-textfield-icon-s"
              [tuiTextfieldCleaner]="true"
            >
              <input
                [formControlName]="FormFields.Sim2"
                [maskito]="simMask"
                [tuiUnmaskHandler]="unmaskSim"
                tuiInput
                class="font-extrabold!"
                inputmode="numeric"
              />
            </tui-textfield>
            <tui-error [formControlName]="FormFields.Sim2"></tui-error>
          </div>

          <!--          Защитный чехол-->
          <x-request-device-protective-case-input
            [formControlName]="FormFields.ProtectiveCaseSubform"
          ></x-request-device-protective-case-input>

          <div class="x-input-label">
            {{
              'request_form.devices.add_device.device_install_date_title'
                | translate
            }}
          </div>
          <div>
            <tui-textfield
              xHyphenedStringTuiDateTransformer
              tuiTextfieldSize="m"
            >
              <input
                tuiInputDate
                type="date"
                [formControlName]="FormFields.DeviceInstallDate"
                placeholder="{{
                  'request_form.devices.add_device.device_install_date_placeholder'
                    | translate
                }}"
              />
              <tui-calendar *tuiDropdown />
            </tui-textfield>
          </div>
          <tui-error
            [formControlName]="FormFields.DeviceInstallDate"
          ></tui-error>
          <div class="text-xs x-text-03 ml-2 mt-1">
            {{
              'request_form.devices.add_device.device_install_date_cannot_be_changed'
                | translate
            }}
          </div>
        </div>
        <div class="flex justify-end mt-5 gap-5">
          <button
            tuiButton
            appearance="secondary"
            type="button"
            size="m"
            (click)="cancelAddingNewRequestDevice()"
          >
            {{ 'request_form.devices.add_device.cancel_button' | translate }}
          </button>
          <button
            tuiButton
            type="button"
            size="m"
            (click)="addNewDeviceToRequest$.next()"
            [class.cursor-not-allowed]="formGroup.invalid"
            [class.cursor-pointer]="formGroup.valid"
            [disabled]="formGroup.invalid"
          >
            {{ 'request_form.devices.add_device.save_button' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
}
